// Birthdays in the dashboard's welcome band: today's as chips, the rest of
// the month behind "See all". Active clients and active staff only; a
// client's age is shown, a staff member's never is (lib/birthdays.js).
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadBirthdays, birthdaySub } from '../lib/birthdays';
import { useRole } from './RoleGuard';

const MONTH = (d) => d.toLocaleDateString('en-US', { month: 'long' });

export default function BirthdayRibbon() {
  const navigate = useNavigate();
  const { isAdmin, isCoordinator } = useRole();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const today = new Date();

  useEffect(() => { loadBirthdays().then(setData); }, []);

  if (!data || data.error) return null;
  const { people, staffMissingDob } = data;
  const todays = people.filter(p => p.isToday);
  const later = people.length - todays.length;
  if (!people.length && !(isAdmin && staffMissingDob)) return null;

  // Profiles open for office staff; others see the names without a link.
  const go = (p) => { if (isCoordinator) navigate(p.kind === 'client' ? `/clients/${p.id}` : `/hr/personnel/${p.id}`); };

  return (
    <div className="dash-bday">
      <div className="dash-bday-row">
        <span aria-hidden="true">🎂</span>
        <b className="dash-bday-title">{todays.length ? 'Birthdays today' : `No birthdays today`}</b>
        {todays.map(p => (
          <button key={p.key} type="button" className="dash-bday-chip" onClick={() => go(p)}>
            <span className={`dash-bday-who ${p.kind}`}>{p.type}</span>
            {/* The label already says Client / Staff / Agency; a role is all that is left to add. */}
            {p.name}{p.kind === 'client' ? ` · ${birthdaySub(p)}` : p.role ? ` · ${p.role}` : ''}
          </button>
        ))}
        <button type="button" className="dash-bday-more" onClick={() => setOpen(o => !o)} aria-expanded={open}>
          {later ? `+${later} more in ${MONTH(today)}` : `${MONTH(today)}`} · <u>{open ? 'Hide' : 'See all'}</u>
        </button>
      </div>
      {open && (
        <div className="dash-bday-list">
          {people.length === 0 && <div className="dash-bday-empty">No birthdays on file this month.</div>}
          {people.map(p => (
            <button key={p.key} type="button" onClick={() => go(p)}
              className={`dash-bday-line${p.isToday ? ' today' : ''}${p.isPast ? ' past' : ''}`}>
              <span className="dash-bday-day">{p.isToday ? 'Today' : `${MONTH(today).slice(0, 3)} ${p.day}`}</span>
              <span className="dash-bday-name">{p.name}</span>
              <span className="dash-bday-sub">{birthdaySub(p)}</span>
            </button>
          ))}
          {isAdmin && staffMissingDob > 0 && (
            <button type="button" className="dash-bday-missing" onClick={() => navigate('/hr/staff-records?missing=dob')}>
              {staffMissingDob} active staff {staffMissingDob === 1 ? 'has' : 'have'} no birthday on file →
            </button>
          )}
        </div>
      )}
    </div>
  );
}
